import { Avatar, Card, Icon, Tag, Typography } from "@ann/web-components";
import { ItemContainerEmailHistory, ItemEmailHistory, ItemEmailHistoryHeader, HeaderActionContainer, ItemEmailHistoryMeta, FromToContainer, MetaItem, ItemEmailHistoryBody, CcItemsContainer, SummaryCardContainer, SummaryCardHeader, SummaryHeaderLeftContainer, HistoryContainer, MainContainer, AvatarContainer, DateContainer, IconContainer } from "./emailHistory.styled";
import { useState } from "react";


const ItemEmailSend = ({ item }) => {
    const [isOpen, setIsOpen] = useState(true);

    const handleOpen = () => {
        setIsOpen(!isOpen);
    }

    return (
        <ItemContainerEmailHistory>
            <AvatarContainer>
                <Avatar
                    size="lg"
                    src="https://i.pravatar.cc/40"
                />
            </AvatarContainer>
            <Card className="col-2">
                <ItemEmailHistory>
                    <ItemEmailHistoryHeader>
                        <DateContainer>
                            <Typography
                                category="body"
                                weight="regular"
                                size="small"
                            >
                                {item.time}
                            </Typography>
                        </DateContainer>
                        <HeaderActionContainer>
                            {
                                isOpen ? (
                                    <IconContainer>
                                        <Icon name="chevronUp" onClick={handleOpen} />
                                    </IconContainer>
                                ) : (
                                    <IconContainer>
                                        <Icon name="chevronDown" onClick={handleOpen} />
                                    </IconContainer>
                                )
                            }
                            <IconContainer>
                                <Icon name="dotsMenu" />
                            </IconContainer>

                        </HeaderActionContainer>
                    </ItemEmailHistoryHeader>
                    {
                        isOpen && (
                            <>
                                <ItemEmailHistoryMeta>
                                    <FromToContainer>
                                        <MetaItem>
                                            <Typography category="subtitle" weight="bold" size="small">From:</Typography>
                                            <Tag
                                                color="neutral"
                                                text={item.from}
                                            />
                                        </MetaItem>
                                        <MetaItem>
                                            <Typography category="subtitle" weight="bold" size="small">To:</Typography>
                                            <Tag
                                                color="neutral"
                                                text={item.to}
                                            />
                                        </MetaItem>
                                    </FromToContainer>
                                    <MetaItem>
                                        <Typography category="subtitle" weight="bold" size="small">Cc:</Typography>
                                        <CcItemsContainer>
                                            {item.cc.map((cc) => (
                                                <Tag
                                                    color="neutral"
                                                    text={cc}
                                                />
                                            ))}
                                        </CcItemsContainer>

                                    </MetaItem>
                                </ItemEmailHistoryMeta>
                                <ItemEmailHistoryBody>
                                    <Typography category="body" weight="regular" size="medium" color="body">
                                        {item.body}
                                    </Typography>

                                </ItemEmailHistoryBody>
                            </>

                        )
                    }
                </ItemEmailHistory>
            </Card>
        </ItemContainerEmailHistory>


    );
}

const ItemEmailReceive = ({ item }) => {
    const [isOpen, setIsOpen] = useState(true);

    const handleOpen = () => {
        setIsOpen(!isOpen);
    }

    return (
        <ItemContainerEmailHistory>
            <Card className="col-2">
                <ItemEmailHistory>
                    <ItemEmailHistoryHeader>
                        <DateContainer>
                            <Typography
                                category="body"
                                weight="regular"
                                size="small"
                            >
                                {item.time}
                            </Typography>

                        </DateContainer>

                        <HeaderActionContainer>
                            {
                                isOpen ? (
                                    <IconContainer>
                                        <Icon name="chevronUp" onClick={handleOpen} />
                                    </IconContainer>
                                ) : (
                                    <IconContainer>
                                        <Icon name="chevronDown" onClick={handleOpen} />
                                    </IconContainer>
                                )
                            }
                            <IconContainer>
                                <Icon name="dotsMenu" />
                            </IconContainer>

                        </HeaderActionContainer>
                    </ItemEmailHistoryHeader>
                    {
                        isOpen && (
                            <>
                                <ItemEmailHistoryMeta>
                                    <FromToContainer>
                                        <MetaItem>
                                            <Typography category="subtitle" weight="bold" size="small">From:</Typography>
                                            <Tag
                                                color="neutral"
                                                text={item.from}
                                            />
                                        </MetaItem>
                                        <MetaItem>
                                            <Typography category="subtitle" weight="bold" size="small">To:</Typography>
                                            <Tag
                                                color="neutral"
                                                text={item.to}
                                            />
                                        </MetaItem>
                                    </FromToContainer>
                                    <MetaItem>
                                        <Typography category="subtitle" weight="bold" size="small">Cc:</Typography>
                                        <CcItemsContainer>
                                            {item.cc.map((cc) => (
                                                <Tag
                                                    color="neutral"
                                                    text={cc}
                                                />
                                            ))}
                                        </CcItemsContainer>

                                    </MetaItem>
                                </ItemEmailHistoryMeta>
                                <ItemEmailHistoryBody>
                                    <Typography category="body" weight="regular" size="medium" color="body">
                                        {item.body}
                                    </Typography>

                                </ItemEmailHistoryBody>
                            </>

                        )
                    }
                </ItemEmailHistory>
            </Card>
            <AvatarContainer>
                <Avatar
                    size="lg"
                    src="https://i.pravatar.cc/40"
                />
            </AvatarContainer>
        </ItemContainerEmailHistory>


    );
}

const SummaryCard = () => {
    return (
        <Card size="small">
            <SummaryCardContainer>
                <SummaryCardHeader>
                    <SummaryHeaderLeftContainer>
                        <Icon name="aiChat" size="medium" />
                        <Typography category="subtitle" weight="bold" size="medium">Summary</Typography>
                    </SummaryHeaderLeftContainer>
                    <Icon name="close" size="medium" />
                </SummaryCardHeader>
            </SummaryCardContainer>
            <Typography category="body" weight="regular" size="medium">Reminder sent about oil change. Customer requests to schedule appointment for the following week and confirms proposed date.</Typography>
        </Card>
    )
}

const EmailHistory = ({ emailHistory }) => {
    return (
        <MainContainer>
            <HistoryContainer>

                {
                    emailHistory.map((item) => (
                        item.type === "send" ? (
                            <ItemEmailSend key={item.id} item={item} />
                        ) : (
                            <ItemEmailReceive key={item.id} item={item} />
                        )
                    ))
                }

            </HistoryContainer>
            <SummaryCard />
        </MainContainer>

    )
}


export default EmailHistory;